export type ShipmentType = 'supplier' | 'internal' | 'brand';

export const defaultCouriers = ['UPS', 'PostNord'];
